/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2025-08-21 13:48:23
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2025-09-22 23:25:36
 * @FilePath: /isp_International/src/api/newApi/user.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http, { messageHttp } from '../axios';

// 显式类型，避免与 requestUserConfig 返回类型互相引用（TS2456）
type UserConfigResponse = Record<string, any>;

let cachedUserConfig: UserConfigResponse | null = null;
let inflightUserConfig: Promise<UserConfigResponse> | null = null;

function requestUserConfig(params: any = {}) {
  return http('get', '/jdig/settings/auth', params, false, true) as Promise<UserConfigResponse>;
}

export function clearUserConfigCache() {
  cachedUserConfig = null;
  inflightUserConfig = null;
}

/** 全站复用：同一时刻只发起一次 /jdig/settings/auth 请求 */
export function getUserConfig(params: any = {}, forceRefresh = false) {
  if (!forceRefresh && cachedUserConfig) {
    return Promise.resolve(cachedUserConfig);
  }

  if (!forceRefresh && inflightUserConfig) {
    return inflightUserConfig;
  }

  inflightUserConfig = requestUserConfig(params)
    .then(res => {
      cachedUserConfig = res;
      return res;
    })
    .catch(error => {
      console.log('网络异常~', error);
      throw error;
    })
    .finally(() => {
      inflightUserConfig = null;
    });

  return inflightUserConfig;
}

export function getCustomerInfo(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/customer/info', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
